import dayjs from "dayjs";
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

import { Text } from "@components/Text";
import { COLOR_WHITE } from "@static/COLORS";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(43, 47, 50, 1);
  border-radius: 12px;
  overflow: hidden;
`;

export const WidgetDate = () => {
  const [currentDay, setCurrentDay] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const [fontSize, setFontSize] = useState(16);
  const containerRef = useRef(null);
  const [isFontSizeReady, setIsFontSizeReady] = useState(false);

  const updateFontSize = () => {
    if (containerRef.current) {
      const { width, height } = containerRef.current.getBoundingClientRect();
      const newFontSize = Math.min(width, height) * 0.16;
      setFontSize(newFontSize);
      setIsFontSizeReady(true);
    }
  };

  const updateDate = () => {
    setCurrentDay(dayjs().format("ddd MMM"));
    setCurrentDate(dayjs().format("D"));
  };

  useEffect(() => {
    updateDate();
    const resizeObserver = new ResizeObserver(updateFontSize);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }
    updateFontSize();
    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <Container ref={containerRef}>
      {isFontSizeReady && (
        <>
          <Text
            fontFamily="NotoSansThaiLooped"
            color={COLOR_WHITE}
            fontWeight="700"
            style={{
              fontSize: `${fontSize}px`,
              whiteSpace: "nowrap",
            }}
          >
            {currentDay}
          </Text>
          <Text
            fontFamily="NotoSansThaiLooped"
            color={COLOR_WHITE}
            fontWeight="400"
            style={{
              fontSize: `${fontSize}px`,
              whiteSpace: "nowrap",
            }}
          >
            {currentDate}
          </Text>
        </>
      )}
    </Container>
  );
};
